import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSinglestoreComponent } from './simple-icons-singlestore.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSinglestoreComponent ],
    exports:      [ SimpleIconsSinglestoreComponent ],
    bootstrap:    []
})
export class SimpleIconsSinglestoreModule {}
